import { render } from "./LayoutSidenav.vue?vue&type=template&id=01d66663"
import script from "./LayoutSidenav.vue?vue&type=script&lang=js"
export * from "./LayoutSidenav.vue?vue&type=script&lang=js"

import "./LayoutSidenav.vue?vue&type=style&index=0&id=01d66663&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__